import { Injectable } from '@angular/core';

import { forkJoin, map, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SubscriptionService } from './subscription.service';
import { SessionService } from '../session.service';

@Injectable({
  providedIn: 'root'
})
export class EnsureSubscriptionResolver {
  constructor(private subscription: SubscriptionService, private session: SessionService) {
  }

  resolve(): Observable<any> {
    const needsBilling = !this.subscription.credentials?.publishableKey;
    const needsPlans = !this.subscription.plans?.length;

    if (!needsBilling && !needsPlans) {
      return of({ billing: this.subscription.credentials, plans: this.subscription.plans });
    }

    const requests: Observable<any>[] = [
      needsBilling ? this.subscription.getBilling() : of(this.subscription.credentials),
      needsPlans ? this.subscription.getPlans() : of(this.subscription.plans)
    ];

    return forkJoin(requests).pipe(
      map((reqs) => ({ billing: reqs[0], plans: reqs[1] })),
      tap(() => { if (needsBilling || needsPlans) { this.session.clearAwaitingInitialSetup(); } }),
      catchError(() => of({ billing: null, plans: [] }))
    );
  }
}
